import { useActiveLocation } from "../activeLocation";
import { CustomerOperationsView } from "./CustomerOperationsView";
import { useCustomerOperations } from "./useCustomerOperations";
import { useReturnUnit } from "../returnUnit/useReturnUnit";
import { ReturnUnitModal } from "../returnUnit/ReturnUnitModal";
import { CustomerSession } from "./types";

export function createCustomerOperations(managementBase: string) {
  return function CustomerOperations() {
    const { locationId, name } = useActiveLocation();
    const query = useCustomerOperations(locationId);

    const ret = useReturnUnit<CustomerSession>({
      managementBase,
      invalidateKey: ["customerOperations", locationId],
      getUnitId: (session) => session.unitId,
    });

    const returningSessionId = ret.isPending ? ret.pending?.id ?? null : null;

    return (
      <>
        <CustomerOperationsView
          data={query.data}
          isLoading={query.isLoading}
          isError={query.isError}
          error={query.error}
          locationLabel={name}
          onReturnUnit={ret.open}
          returningSessionId={returningSessionId}
        />

        <ReturnUnitModal
          opened={ret.pending !== null}
          onClose={ret.close}
          onConfirm={ret.confirm}
          isPending={ret.isPending}
        >
          Return {ret.pending?.customerName}'s unit to storage? The robot will move
          the unit off the dock.
        </ReturnUnitModal>
      </>
    );
  };
}
